if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        this.submitButtons = this.querySelectorAll('[type="submit"]');
        this.submitButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            this.lastClickedButton = btn;
          });
        });

        if (document.querySelector('cart-drawer')) {
          this.submitButtons.forEach(btn => {
            if (btn.dataset.skipCart !== 'true' && btn.name !== 'checkout') {
              btn.setAttribute('aria-haspopup', 'dialog');
            }
          });
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.sectionId}`);
        this.customFields = document.querySelectorAll(`[id^='CustomField-${this.dataset.sectionId}-']`);
        this.variantInputs = this.form.querySelector(".product-form__variants");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const activeBtn = evt.submitter || this.lastClickedButton || this.submitButton;
        if (!activeBtn || activeBtn.getAttribute('aria-disabled') === 'true' || activeBtn.disabled) return;

        this.handleErrorMessage();

        this.activeSubmitButton = activeBtn;
        activeBtn.setAttribute('aria-disabled', 'true');
        activeBtn.classList.add('loading');
        const spinner = activeBtn.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.remove('hidden');
        }
        
        let hasVariants = false;
        if (!this.variantInputs && this.form) {
          this.variantInputs = this.form.querySelector(".product-form__variants");
          if (!this.variantInputs) {
            this.variantInputs = document.createElement("div");
            this.variantInputs.className = "hidden product-form__variants";
            this.form.appendChild(this.variantInputs);
          }
        }

        const isSticky = activeBtn && (activeBtn.id?.includes('StickyAtc') || activeBtn.closest('sticky-atc') || activeBtn.classList?.contains('sticky-atc__buy-btn'));
        const isUpsell = this.closest(".cart-upsell");
        if (isSticky && this.variantInputs) {
          this.variantInputs.innerHTML = "";
        }
        const selectedRadio = !isSticky && !isUpsell && ((this.quantityBreaks ? this.quantityBreaks.querySelector("input[name=\"quantity\"]:checked") : null) ||
                              document.querySelector(".quantity-breaks-container input[name=\"quantity\"]:checked"));
        const refillRadio = !isSticky && !isUpsell && document.querySelector("#refill-quantity-breaks-container input[name=\"quantity\"]:checked");
        const bundleInput = selectedRadio ? (selectedRadio.dataset.input || selectedRadio.id) : null;
        const option2RefillVariantId = "47467201659068"; // $15.00
        const option3RefillVariantId = "47439012987068"; // $14.99

        const toyBundleVariantMap = {
          "47463300432060": "47467211063484", // Navy Blue ($22.50)
          "47463300497596": "47467211096252", // Pink ($22.50)
          "47463300563132": "47467211129020", // Yellow ($22.50)
          "47463300661436": "47467211161788"  // Blue ($22.50)
        };

        if (refillRadio && this.variantInputs) {
          let itemsToAdd = [];
          if (refillRadio.id === "refill-quantity-1") {
            itemsToAdd = [
              { id: "47439011676348", quantity: 1 }
            ];
          } else if (refillRadio.id === "refill-quantity-2") {
            itemsToAdd = [
              { id: "47467201659068", quantity: 1, properties: { "_bundle": "refill_double_pack" } },
              { id: "47439012987068", quantity: 1, properties: { "_bundle": "refill_double_pack" } }
            ];
          }
          if (itemsToAdd.length > 0) {
            hasVariants = true;
            let quantityInputs = "";
            for (let i = 0; i < itemsToAdd.length; i++) {
              let item = itemsToAdd[i];
              quantityInputs += `<input type="hidden" name="items[${i}][quantity]" value="${item.quantity}">`;
              quantityInputs += `<input type="hidden" name="items[${i}][id]" value="${item.id}">`;
              if (item.properties) {
                for (const [k, v] of Object.entries(item.properties)) {
                  quantityInputs += `<input type="hidden" name="items[${i}][properties][${k}]" value="${v}">`;
                }
              }
            }
            this.variantInputs.innerHTML = quantityInputs;
          }
        } else if (bundleInput && this.variantInputs) {
          const mainVariantId = this.form.querySelector("[name=\"id\"]")?.value || this.variantIdInput?.value;
          let itemsToAdd = [];

          if (bundleInput === "input_1" || selectedRadio?.id === "quantity1") {
            itemsToAdd = [
              { id: mainVariantId, quantity: 1 }
            ];
          } else if (bundleInput === "input_2" || selectedRadio?.id === "quantity2") {
            itemsToAdd = [
              { id: mainVariantId, quantity: 1 },
              { id: option2RefillVariantId, quantity: 1 }
            ];
          } else if (bundleInput === "input_3" || selectedRadio?.id === "quantity3") {
            const bundleToyId = toyBundleVariantMap[mainVariantId] || mainVariantId;
            itemsToAdd = [
              { id: bundleToyId, quantity: 2 },
              { id: option3RefillVariantId, quantity: 1 }
            ];
          }

          if (itemsToAdd.length > 0) {
            hasVariants = true;
            let quantityInputs = "";
            for (let i = 0; i < itemsToAdd.length; i++) {
              let item = itemsToAdd[i];
              quantityInputs += `<input type="hidden" name="items[${i}][quantity]" value="${item.quantity}">`;
              quantityInputs += `<input type="hidden" name="items[${i}][id]" value="${item.id}">`;
              if (this.customFields) {
                this.customFields.forEach(field => {
                  quantityInputs += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.value}">`;
                });
              }
            }
            this.variantInputs.innerHTML = quantityInputs;
          }
        } else if (this.quantityBreaks && this.variantInputs && this.quantityBreaks.formVariants?.length > 0) {
          let quantityInputs = "";
          hasVariants = true;
          for (let i = 0; i < this.quantityBreaks.formVariants.length; i++) {
              let variant = this.quantityBreaks.formVariants[i];
              quantityInputs += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
              quantityInputs += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
              this.customFields.forEach(field => {
                  quantityInputs += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.value}">`;
              });
          }
          this.variantInputs.innerHTML = quantityInputs;
        }
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (hasVariants) {
          let options = this.dataset.options ? this.dataset.options.split(",") : [];
          let fieldsToDelete = ["id", "quantity", ...options];
          for (let field of fieldsToDelete) {
              formData.delete(field);
          }
        }
        config.body = formData;
        if (!this.skipCart) {
          if (activeBtn && (activeBtn.dataset.skipCart === "true" || activeBtn.name === "checkout" || activeBtn.classList.contains('buy-now-button'))) {
            this.skipCart = true;
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = activeBtn.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              activeBtn.setAttribute('aria-disabled', 'true');
              const textSpan = activeBtn.querySelector('span');
              if (textSpan) textSpan.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            const activeSubmitBtn = this.activeSubmitButton || this.submitButton;
            if (activeSubmitBtn) {
              activeSubmitBtn.classList.remove('loading');
              if (!this.error) activeSubmitBtn.removeAttribute('aria-disabled');
              const spinner = activeSubmitBtn.querySelector('.loading__spinner');
              if (spinner) {
                spinner.classList.add('hidden');
              }
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const allButtons = this.querySelectorAll('[type="submit"]');
        allButtons.forEach(btn => {
          const span = btn.querySelector('span');
          if (disable) {
            btn.setAttribute('disabled', 'disabled');
            if (span && text) span.textContent = text;
          } else {
            btn.removeAttribute('disabled');
            if (span) {
              if (btn.classList.contains('buy-now-button') || btn.dataset.skipCart === 'true') {
                span.textContent = 'BUY NOW (50% OFF)';
              } else {
                span.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Add to cart';
              }
            }
          }
        });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
